import * as React from 'react';
import { SVGProps } from 'react';

const SvgCheckmarkFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-4.226-3.656a1 1 0 0 1-.007 1.418l-7.33 7.222-3.998-3.99a1 1 0 0 1-.001-1.415l.627-.627a1 1 0 0 1 1.413-.001l2.024 2.016 5.242-5.242a1 1 0 0 1 1.416.002l.614.617Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCheckmarkFilled;
